import { render, staticRenderFns } from "./CidadeAutocomplete.vue?vue&type=template&id=954203b8&"
import script from "./CidadeAutocomplete.vue?vue&type=script&lang=js&"
export * from "./CidadeAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports